import { replaceParameters } from '@/common-utils/functions/restUtils';
import { client } from '@/common-utils/libraries/axios/axios';
import { TOKEN } from '../apiUrls';
import userFields from '@/app/modules/users/monetic/fields/userFields';

/**
 * @param responseData response.data object
 * @param responseData.hasMfa boolean
 *
 * @param data
 * @returns Mapped data object
 */
function mapResponseData(data) {
    return data[userFields.ADVANCED_AUTH.key];
}

const queryGetToken = (uuid) => {
    return {
        queryKey: [TOKEN.TOKEN.queryKey, uuid],
        queryFn: async () => {
            const response = await client.get(replaceParameters(TOKEN.TOKEN.url, { uuid }));
            console.log(response.data);
            return response.data;
        }
    };
};

export default queryGetToken;